import { gql } from '@apollo/client';

export const ADD_POST_DRAFT_MUTATION = gql`
    mutation addPostDraft($input: NewDraftInput) {
        addPostDraft(input: $input) {
            id
            parentPostId
            PK
            hasStoryAnalysis
            storyAnalysis
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            article
            createdAt
            updatedAt
        }
    }
`;
